import { AfterViewInit, Component, EventEmitter, HostListener, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { tap, timeInterval } from 'rxjs/operators';
import { Router } from '@angular/router';
import { EventiDataSource } from 'src/app/services/eventi.datasource';
import { EventiService } from 'src/app/services/eventi.service';
import { merge } from 'rxjs';
import { MatSelect } from '@angular/material/select';
import { DialogService } from 'src/app/services/dialog.service';
import { Toolbar, ToolbarEvent } from 'src/app/shared/components/toolbar/toolbar';
import { AlertsCenterService } from 'src/app/core/services/alerts-center.service';
import { EntiService } from 'src/app/services/enti.service';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { StatiEvento } from 'src/app/model/StatiEvento.enum';

@Component({
  selector: 'app-lista-eventi',
  templateUrl: './lista-eventi.component.html',
  styleUrls: ['./lista-eventi.component.css'],
})
export class ListaEventiComponent implements AfterViewInit {
  arrowFlag: boolean = false;
  dettaglio: boolean = false;
  eventDetail: any;
  risultatiPerPagina: number = 10;

  dataSource: EventiDataSource;

  eventiSearchableDto: ModelEventiCalamitosi.EventiSearchableDto = {
    idEvento: null,
    dpgr: null,
    dataEventoDa: null,
    dataEventoA: null,
    primaDataChiusuraRaccolta: null,
    descrizione: null,
    stato: null,
    ocdpc:null
  };

  //Variabili per modal
  title: string;
  content: string;
  confirmed: string;
  inputData: string;


  public form: FormGroup;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('orderBy') orderBy: MatSelect;


  /**
   *
   *
   * @type {EventEmitter<ToolbarEvent>}
   * @memberof DataTableComponent
   */
  @Output()
  public onToolbarEvent: EventEmitter<ToolbarEvent> = new EventEmitter();

  /**
 *
 * Filtri di ricerca impostati dall'utente
 * @type {ModelEventiCalamitosi.EventiSearchableDto}
 */
  public searchFilters: ModelEventiCalamitosi.EventiSearchableDto = {} as ModelEventiCalamitosi.EventiSearchableDto;
  isLoading: boolean = false;
  openToggle: number = 0;

  private buildForm(): void {
    let group = {
      idEvento: new FormControl(null, null),
      ocdpc: new FormControl(null, null),
      dpgr: new FormControl(null, null),
      dataEventoDa: new FormControl(null, null),
      dataEventoA: new FormControl(null, null),
      descrizione: new FormControl(null, null),
      primaDataChiusuraRaccolta: new FormControl(null, null),
      stato: new FormControl(null, null),
    }
    this.form = new FormGroup(group);
  }

  constructor(
    private eventiService: EventiService,
    private router: Router,
    private lsEventiDialogSvc: DialogService,
    private alertsCenterService: AlertsCenterService,
    private authenticationService: AuthenticationService) {
  }

  ngOnInit(): void {
    this.buildForm();
    this.dataSource = new EventiDataSource(this.eventiService);
    this.dataSource.errors$.subscribe(res => {
      if (res) this.alertsCenterService.showAlert({
        message: `Errore lettura dati`,
        type: 'danger',
        autoClosable: false
      });
    })
    //
  }

  //rimane in ascolto: se il click non è fatto sull'icona chiude il menù
  @HostListener('document:click', ['$event'])
  documentClick(event) {
    if (event.srcElement.innerText !== 'more_horiz') this.openToggle = 0;
  }

  //questa variabile, associata a *matHeaderRowDef, definisce l'ordine di visualizzazione delle colonne
  displayedColumns: string[] = ['dpgr', 'denominazione', 'stato', 'ocdpc', 'dataEvento', 'actions'];

  ngAfterViewInit() {
    setTimeout(() => {
      this.sort.direction = "desc";
      this.sort.active = "dataEvento";
      this.dataSource.loadEventi('', this.eventiSearchableDto, 'dataEvento,'+this.sort.direction, 0, this.risultatiPerPagina);

      this.form.valueChanges.subscribe(() => this.paginator.pageIndex = 0);
      this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

      merge(this.sort.sortChange, this.paginator.page)
        .pipe(
          tap(() => {
            this.ricercaListaEventi();
          }))
        .subscribe();

      this.dataSource.counter$
        .pipe(
          tap((count) => {
            this.paginator.length = count;
          })
        )
        .subscribe();
    });
  }

  public ricercaListaEventi(resetPage?: boolean): void {
    if (this.form.controls.dataEventoA.value !== ""
      && this.form.controls.dataEventoA.value !== null
      && this.form.controls.dataEventoA.value !== undefined) {
      if (this.form.controls.dataEventoDa.value > this.form.controls.dataEventoA.value) {
        let message = "Data di inizio maggiore della data di fine"
        this.alertsCenterService.showAlert({
          message: message,
          type: 'danger',
          autoClosable: false
        });
        return
      }
    }

    this.searchFilters = {
      idEvento: this.form.controls['idEvento'].value !== "" ? this.form.controls['idEvento'].value : null,
      dpgr: this.form.controls['dpgr'].value !== "" ? this.form.controls['dpgr'].value : null,
      dataEventoDa: this.form.controls['dataEventoDa'].value !== "" ? this.form.controls['dataEventoDa'].value : null,
      dataEventoA: this.form.controls['dataEventoA'].value !== "" ? this.form.controls['dataEventoA'].value : null,
      primaDataChiusuraRaccolta: this.form.controls['primaDataChiusuraRaccolta'].value !== "" ? this.form.controls['primaDataChiusuraRaccolta'].value : null,
      descrizione: this.form.controls['descrizione'].value !== "" ? this.form.controls['descrizione'].value : null,
      stato: this.form.controls['stato'].value !== "" ? this.form.controls['stato'].value : null,
      ocdpc: this.form.controls['ocdpc'].value !== "" ? this.form.controls['ocdpc'].value : null,
    }

    this.dataSource.loadEventi('', this.searchFilters, this.sort.active + "," + this.sort.direction, this.paginator.pageIndex, this.paginator.pageSize);

  }

  openDeleteConfirmDialog(idEvento: number) {
    let title = 'Cancellazione evento';
    let message = 'Vuoi davvero eliminare questo evento?'
    this.lsEventiDialogSvc.openDialog(title, message).subscribe(
      result => {
        this.confirmed = `${result}`;
        if (this.confirmed == "true") {
          this.cancellaEvento(idEvento);
        }
      }
    );
  }

  public cancellaEvento(idEvento: number): void {
    this.isLoading = true;
    this.eventiService.deleteEvento(idEvento).subscribe(results => {
      this.alertsCenterService.showAlert({
        message: `Cancellazione effettuata con successo`,
        type: 'success',
        autoClosable: false
      });
      this.isLoading = false;
      this.ricercaListaEventi();
    }, err => {
      this.alertsCenterService.showAlert({
        message: err.error.esitoServizio.descrizioneEsito,
        type: 'danger',
        autoClosable: false
      });
      this.isLoading = false;
    })
  }


  openDuplicateInputDialog(data: ModelEventiCalamitosi.EventoDto) {
    let title = 'Duplicazione evento';
    let message = 'Definire un nuovo DGPR da assegnare all' + "'" + 'evento.';
    this.lsEventiDialogSvc.openInputDialog(title, message, true, 'DPGR*').subscribe(
      result => {
        if (result) this.duplicaEvento(data, result);
      }
    );
  }

  duplicaEvento(data: ModelEventiCalamitosi.EventoDto, dpgr: string) {
    this.isLoading = true;
    data.dpgr = dpgr;
    this.eventiService.dupicateEvt(data).subscribe(results => {
      this.alertsCenterService.showAlert({
        message: `Duplicazione avvenuta con successo`,
        type: 'success',
        autoClosable: false
      });
      this.isLoading = false;
      this.ricercaListaEventi();
    }, err => {
      this.alertsCenterService.showAlert({
        message: err.error.esitoServizio.descrizioneEsito,
        type: 'danger',
        autoClosable: false,
      });
    });
    this.isLoading = false;
  }

  onRowClicked(row) {
  }

  onNavigate(path) {
    this.router.navigate([path])
  }

  public isAbilitatoInserimento() {
    return sessionStorage.getItem("acl") == "dpcpl" || sessionStorage.getItem("acl") == "edel";
  }

  /**
 *
 *
 * @private
 * @memberof SearchComponent
 */
  public generateToolBar(stato: String): Toolbar {
    let toolbar: Toolbar;
    toolbar = { toolbarCss: 'toolbar-vertical', actions: [] }
    if (sessionStorage.getItem("acl") == 'dgpe') {
      toolbar.actions.push(
        {
          btnTitle: 'Dettaglio',
          btnIconClass: 'article',
          btnActionEvent: 'detail',
          btnCssClass: 'btn btn-secondary'
        }
      )
      return toolbar
    }
    if (stato === StatiEvento.POST_EMERGENZA || stato == StatiEvento.RACCOLTA_DATI_PE || stato === StatiEvento.ATTESA_EMERGENZA) {
      toolbar.actions.push(
        {
          btnTitle: 'Dettaglio',
          btnIconClass: 'article',
          btnActionEvent: 'detail',
          btnCssClass: 'btn btn-secondary'
        },
        {
          btnTitle: 'Duplica',
          btnIconClass: 'content_copy',
          btnActionEvent: 'duplicate',
          btnCssClass: 'btn btn-secondary'
        }
      )
      return toolbar
    }
    else if (stato === StatiEvento.EMERGENZA_NON_RICONOSCIUTA) {
      toolbar.actions.push(
        {
          btnTitle: 'Dettaglio',
          btnIconClass: 'article',
          btnActionEvent: 'detail',
          btnCssClass: 'btn btn-secondary'
        }
      )
      return toolbar
    }
    else {
      toolbar.actions.push(
        {
          btnTitle: 'Dettaglio',
          btnIconClass: 'article',
          btnActionEvent: 'detail',
          btnCssClass: 'btn btn-secondary'
        },
        {
          btnTitle: 'Modifica',
          btnIconClass: 'create',
          btnActionEvent: 'edit',
          btnCssClass: 'btn btn-secondary'
        },
        {
          btnTitle: 'Duplica',
          btnIconClass: 'content_copy',
          btnActionEvent: 'duplicate',
          btnCssClass: 'btn btn-secondary'
        }
      )
      if (stato === StatiEvento.IN_BOZZA) {
        toolbar.actions.push(
          {
            btnTitle: 'Elimina',
            btnIconClass: 'delete',
            btnActionEvent: 'remove',
            btnCssClass: 'btn btn-primary'
          }
        )
      }
      return toolbar
    }
  }

  public handleToolbarEvent(event: ToolbarEvent): void {
    if (event.event === 'edit') {
      this.onNavigate('modifica-evento/' + event.data.idEvento)
    }
    else if (event.event === 'detail') {
      this.onNavigate('dettaglio-evento/' + event.data.idEvento)
    }
    else if (event.event === 'remove') {
      this.openDeleteConfirmDialog(event.data.idEvento);
    }
    else if (event.event === 'duplicate') {
      this.openDuplicateInputDialog(event.data);
    }
  }

  onReset() {
    this.eventiSearchableDto = {
      idEvento: null,
      dpgr: null,
      dataEventoDa: null,
      dataEventoA: null,
      primaDataChiusuraRaccolta: null,
      descrizione: null,
      stato: null,
      ocdpc:null
    };
    this.form.reset();
    this.dataSource.loadEventi('', this.eventiSearchableDto, 'dataEvento,DESC', 0, this.risultatiPerPagina);
  }
}
